import { ButtonProps } from '@mui/material';
import classNames from 'classnames';
import Iconify from 'src/components/iconify';
import { CustomActionButton } from './styles';

export const AiStopButton = ({
  onClick,
  isFromNav,
}: ButtonProps & { isFromNav?: boolean }) => (
  <CustomActionButton
    color="warning"
    variant="contained"
    onClick={onClick}
    className={classNames({ isFromNav })}
  >
    <Iconify icon="tabler:player-stop-filled" />
  </CustomActionButton>
);
